import { routerReducer } from 'react-router-redux';

import requests from './requests';
import app from './app';
import cohorts from './cohorts';
import library from './library';
import errors from './errors';

export default function (state, action) {
  return {
    app: app(state.app, action),
    cohorts: cohorts(state.cohorts, action, state.app),
    requests: requests(state.requests, action),
    routing: routerReducer(state.routing, action),
    library: library(state.library, action),
    errors: errors(state.errors, action),
  };
}



/** WEBPACK FOOTER **
 ** ./src/js/reducers/index.js
 **/